<template>
<div class="chapter">
<div class="inner_page">
<p class="C325"><a id="page_23">PART I</a></p><a id="page_23">
<p class="C326"><em>Generalities</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_PART_I__GENERALITIES.vue?2caa3910